export enum MenuStyle {
  OPEN = "mega-menu-content show",
  CLOSE = "mega-menu-content",
}

export enum MenuButtonStyle {
  SELECTED = "dropbtn selected",
  UN_SELECTED = "dropbtn",
}

export enum MenuItemIds {
  New = "New",
  Import = "Import",
  Export = "Export",
  Save = "Save",
  SaveAs = "SaveAs",
}

export const Menus = [
  // {id: MenuItemIds.New, displayName: "New"},
  // {id: MenuItemIds.Import, displayName: "Import"},
  // {id: MenuItemIds.Export, displayName: "Export"},
  // {id: MenuItemIds.Save, displayName: "Save"},
  {
    id: MenuItemIds.SaveAs,
    displayName: "US.USC.TEMPLATEEDITOR:TEMPLATE_EDITOR.SAVE_AS",
  },
];
